import Select from "react-select";
import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { useAIStream } from "../../../../Hooks/useAiStream";
import request from "../../../../Api/request";
import Spacer from "../../../../Components/Spacer";
import Grid from "../../../../Components/Grid";
import Button from "../../../../Components/Button";
import { Text } from "../../../../Components/Text";
import { AutoGrowTextArea } from "../../../../Components/Inputs/AutoGrowTextArea";
import TextInput from "../../../../Components/Inputs/Text";

import css from "./styles.styl";

const ACTIONS = [
	{ value: "ANALYZE:SERVICE", label: "Analyze Service" },
	{ value: "ANALYZE:BUG", label: "Analyze Bug" },
	{ value: "PROCESS:Bug", label: "Process Bug" },
	{ value: "PROCESS:SERVICE", label: "Process Service" },
];

const TriageTicket = () => {
	const [selectedAction, setSelectedAction] = useState(ACTIONS[0]);
	const [jiraTicketNumber, setJiraTicketNumber] = useState("PY-");

	const { data, makeRequest } = useAIStream({ url: `/api/jira/ticket/${jiraTicketNumber}/analyze` });

	const { data: jiraTicket, refetch: fetchJiraTicket } = useQuery({
		queryKey: ["jira-ticket", jiraTicketNumber],
		queryFn: () => {
			return request({
				url: `/api/jira/ticket/${jiraTicketNumber}`,
				method: "GET",
			});
		},
		enabled: false,
	});

	/**
	 * Does analysis right here in the browser.
	 */
	const analyze = () => {
		makeRequest({ action: selectedAction.value });
	};

	/**
	 * Does extra processing with side effects.
	 */
	const process = () => {
		return request({
			url: `/api/jira/ticket/${jiraTicketNumber}/process`,
			method: "POST",
			data: {
				action: selectedAction.value,
			},
		});
	};

	const execute = () => {
		fetchJiraTicket();

		if (selectedAction.value.startsWith("ANALYZE")) {
			analyze();
		} else if (selectedAction.value.startsWith("PROCESS")) {
			process();
		}
	};

	let renderedStream = data;

	try {
		const jsonText = JSON.parse(data);
		renderedStream = JSON.stringify(jsonText, null, 4);
	} catch (e) {
		// do nothing
	}

	return (
		<div className={css.container}>
			<Spacer size={2} />

			<Grid gap={16} columns={["1fr", "1fr"]}>
				<div className={css.form}>
					<Text>Ticket #</Text>

					<Grid gap={8} columns={["1fr", "200px", "100px"]}>
						<div>
							<TextInput value={jiraTicketNumber} onChange={(val) => setJiraTicketNumber(val)} />
						</div>

						<Select
							value={selectedAction}
							onChange={(value) => setSelectedAction(value)}
							options={ACTIONS}
							isSearchable
							isClearable={false}
						/>

						<Button color="black" onClick={() => execute()}>
							Execute
						</Button>
					</Grid>

					<Spacer size={1} />

					<Text variant="caption" as="p">
						<Text variant="caption" weight="bold">
							Analyze:
						</Text>{" "}
						analyzes ticket right here in the UI.
					</Text>
					<Text variant="caption" as="p">
						<Text variant="caption" weight="bold">
							Process:
						</Text>{" "}
						processes the ticket and updates Jira.
					</Text>

					<Spacer size={2} />

					<Text>Title</Text>
					<AutoGrowTextArea value={jiraTicket?.data?.summary} onChange={() => {}} />

					<Spacer size={2} />

					<Text>Details</Text>
					<AutoGrowTextArea value={jiraTicket?.data?.description} onChange={() => {}} />
				</div>

				<div className={css.copilot}>
					<div className={css.results}>{renderedStream}</div>
				</div>
			</Grid>
		</div>
	);
};

export default TriageTicket;
